import { isLogin } from 'utils/utils'
import { Navigate } from 'react-router-dom'

export const PrivateRoute = ({ children }) => {
    const isAuthenticated = isLogin()

    return isAuthenticated ? children : <Navigate to='/' />
}
